import { LogLevel, LogType } from "../app/shared/models/core/log.models";

export const environment = {
  production: true,
  logLevel: LogLevel.Info,
  logType: LogType.Server,
  recaptchaKey: "#{reCaptchaKey}",
  recaptchaChallengeKey: "#{reCaptchaChallengeKey}"
};
